import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[200],
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          columnGap: 2,
        }}
      >
        <Typography variant="body2" color="textSecondary" align="center">
          © {new Date().getFullYear()} KertMagad - Botha Levente
        </Typography>
        <Link
          component={RouterLink}
          to="/aszf"
          variant="body2"
          color="textSecondary"
          underline="hover"
          sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, px: 1 }}
        >
          Általános Szerződési Feltételek (ÁSZF)
        </Link>
      </Container>
    </Box>
  );
};

export default Footer;
